<template>
    <!-- <el-col :span="24">
        <label>{{label}}</label>
        <el-row :gutter="20" class="pt-1" justify="center">
            <el-col :span="24" :lg="12" align="center">
                <v-time-picker v-model="timeRange.start" :clearable="false" :max-time="timeRange.end" time-picker :is-24="false" teleport-center auto-apply />
            </el-col>
            <el-col :span="24" :lg="12" align="center">
                <v-time-picker v-model="timeRange.end" :clearable="false" :min-time="timeRange.start" time-picker :is-24="false" teleport-center auto-apply />
            </el-col>
            <el-col :span="24" align="center">
                <h3>{{calculateTotalHours}}</h3>
            </el-col>
        </el-row>
    </el-col> -->

    <el-form-item label="Time Range" label-position="top">
        <el-time-picker
            v-model="timeRange"
            size="large"
            is-range
            range-separator="To"
            format="hh:mm A"
            value-format="HH:mm"
            start-placeholder="Start time"
            end-placeholder="End time"
            @change="handleTimeChange"
        />
    </el-form-item>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'
    const emit = defineEmits(['update:modelValue'])
    const props = defineProps({
        modelValue: {
            type: Object,
            default: null,
        },
        label: {
            type: String,
            default: 'Time Range',
        },
    })

    const timeRange = ref(props.modelValue)

    // Handle time change event
    const handleTimeChange = (value: any) => {
        console.log('Selected Time Range:', value)
        emit('update:modelValue', value)
    }
    // import { VTimePicker } from 'vuetify/labs/VTimePicker'
    // import { parse, formatDuration, intervalToDuration } from 'date-fns';
    // import moment from 'moment'
    // function formatTimeToHHmm(time) {
    //     const hours = String(time.hours).padStart(2, '0');   // Pads hours to 2 digits
    //     const minutes = String(time.minutes).padStart(2, '0'); // Pads minutes to 2 digits
    //     return `${hours}:${minutes}`;
    // }
    // export default {
    //     components: {
    //         VTimePicker,
    //     },
    //     props: {
    //         modelValue: null,
    //         label: {
    //             type: String,
    //             default: 'Plan your event'
    //         },
    //     },
    //     data() {
    //         return {
    //             timeRange: {
    //                 start: null,
    //                 end: null,
    //             },
    //         }
    //     },
    //     created() {
    //         if (this.modelValue.start) {
    //             this.timeRange.start = this.timeObject(this.modelValue.start)
    //         }
    //         if (this.modelValue.end) {
    //             this.timeRange.end = this.timeObject(this.modelValue.end)
    //         }
    //     },
    //     methods: {
    //         timeObject(timeString) {
    //             const momentObj = moment(timeString, 'HH:mm');
    //             return {
    //                 hours: momentObj.hours(),
    //                 minutes: momentObj.minutes(),
    //                 seconds: momentObj.seconds(),
    //             };
    //         },
    //     },
    //     computed: {
    //         calculateTotalHours() {
    //             if (this.timeRange.start && this.timeRange.end) {
    //                 const s = formatTimeToHHmm(this.timeRange.start);
    //                 const e = formatTimeToHHmm(this.timeRange.end);
    //                 const start = parse(s, 'HH:mm', new Date());
    //                 const end = parse(e, 'HH:mm', new Date());
    //                 const duration = intervalToDuration({ start, end });
    //                 const formatted = formatDuration({
    //                     hours: duration.hours,
    //                     minutes: duration.minutes,
    //                 });
    //                 var x = {
    //                     start: s,
    //                     end: e
    //                 }
    //                 this.$emit('update:modelValue', x)
    //                 return formatted;
    //             } else {
    //                 return null;
    //             }
    //         },
    //     },
    // }
</script>
